import connectFormikField from '../connectFormikField/connectFormikField'
import InputNum from '@/redesign/components/InputNumber/InputNumber'

const FormikInputNum = connectFormikField(InputNum)

export default FormikInputNum
